import React from 'react';
import { 
  LayoutDashboard, 
  CalendarClock, 
  Wrench, 
  Briefcase, 
  ShieldAlert, 
  HardHat, 
  Truck, 
    Users,
    Receipt,
    Building2,
    Settings,
    HelpCircle,
    FileText,
    Shield
  } from 'lucide-react';
  import { ModuleType } from '../types';
interface SidebarProps {
  activeModule: ModuleType;
  setActiveModule: (module: ModuleType) => void;
  isOpen: boolean;
}

export const Sidebar: React.FC<SidebarProps> = ({ activeModule, setActiveModule, isOpen }) => {
  const menuItems = [
    { id: ModuleType.DASHBOARD, icon: LayoutDashboard, label: 'Command Center', group: 'Core' },
    { id: ModuleType.JOB_PLANNING, icon: CalendarClock, label: 'Job Planning', group: 'Operations' },
    { id: ModuleType.SERVICE_CRM, icon: Wrench, label: 'Service CRM', group: 'Operations' },
    { id: ModuleType.ASSET_MGR, icon: HardHat, label: 'Asset Manager', group: 'Operations' },
    { id: ModuleType.RENTAL_MGR, icon: Truck, label: 'Rental Fleet', group: 'Operations' },
    { id: ModuleType.SALES_CRM, icon: Briefcase, label: 'Sales CRM', group: 'Business' },
    { id: ModuleType.HR_MGR, icon: Users, label: 'HR & Training', group: 'Business' },
    { id: ModuleType.EXPENSE, icon: Receipt, label: 'Expenses', group: 'Business' },
    { id: ModuleType.CONTRACTOR, icon: Building2, label: 'Contractors', group: 'Compliance' },
    { id: ModuleType.HSSE, icon: ShieldAlert, label: 'HSSE Safety', group: 'Compliance' },
    { id: ModuleType.DOC_CONTROL, icon: FileText, label: 'Doc Control', group: 'Compliance' },
    { id: ModuleType.SYSTEM_ADMIN, icon: Shield, label: 'System Admin', group: 'Core' },
  ];

  return (
    <div className={`fixed inset-y-0 left-0 z-50 bg-slate-900 border-r border-slate-800 transition-all duration-300 ${isOpen ? 'w-64' : 'w-20'} overflow-y-auto`}>
      <div className="h-16 flex items-center justify-center border-b border-slate-800 bg-slate-950">
        <div className="flex items-center gap-2 font-bold text-titan-500 text-xl">
           <ShieldAlert className="w-8 h-8" />
           {isOpen && <span>TITAN</span>}
        </div>
      </div>

      <div className="py-4">
        {menuItems.map((item) => (
          <button
            key={item.id}
            onClick={() => setActiveModule(item.id)}
            className={`w-full flex items-center gap-4 px-6 py-3 transition-colors ${
              activeModule === item.id 
                ? 'bg-titan-500/10 text-titan-500 border-r-4 border-titan-500' 
                : 'text-slate-400 hover:bg-slate-800 hover:text-slate-200'
            }`}
          >
            <item.icon className="w-5 h-5 min-w-[20px]" />
            {isOpen && <span className="whitespace-nowrap font-medium text-sm">{item.label}</span>}
          </button>
        ))}
      </div>
      
      {isOpen && (
        <div className="absolute bottom-0 w-full p-4 border-t border-slate-800 bg-slate-950">
            <div className="text-xs text-slate-500 text-center">v2.4.0 • Titan Ecosystem</div>
        </div>
      )}
    </div>
  );
};